import Sicily from './Sicily'

export default Sicily
